
/* Frankster: switch the entire Collection Mega Menu metaobject panel on hover. */
(function () {
  function setup(root) {
    var menus = [];

    if (root.matches && root.matches('[data-frankster-mega]')) {
      menus.push(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('[data-frankster-mega]').forEach(function (el) {
        menus.push(el);
      });
    }

    menus.forEach(function (menu) {
      if (menu.dataset.franksterReady === 'true') return;

      menu.dataset.franksterReady = 'true';

      var panel = menu.querySelector('[data-frankster-panel]');
      var fallback = menu.querySelector(
        'template[data-frankster-default-panel]'
      );

      if (!panel || !fallback) return;

      function render(template) {
        panel.replaceChildren(template.content.cloneNode(true));
      }

      menu.querySelectorAll('[data-frankster-hover-id]').forEach(function (link) {

        function activate() {
          var id = link.getAttribute('data-frankster-hover-id');

          var template = Array.from(
            menu.querySelectorAll('template[data-frankster-panel-id]')
          ).find(function (el) {
            return el.getAttribute('data-frankster-panel-id') === id;
          });

          render(template || fallback);
        }
        link.addEventListener('mouseenter', activate);
        link.addEventListener('focus', activate);
      });

      menu.addEventListener('mouseleave', function () {
        render(fallback);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setup(document);
    });
  } else {
    setup(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    setup(event.target);
  });
})();
